import Link from 'next/link'
import moment from 'moment'
import { useQuery } from 'react-query'
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DesignCanvas from '../../../../../components/DesignCanvas'
import InspirationActionsMenu from '../../../../../components/InspirationActionsMenu'
import CommentBtn from '../../../../../components/social/CommentBtn'
import GiftBtn from '../../../../../components/social/GiftBtn'
import LikeBtn from '../../../../../components/social/LikeBtn'
import { gotoLogIn } from '../../../../../redux/actions/AuthActions'
import { getImageSource } from '../../../../../utils/getImageSource'
import { getUsername } from '../../../../../utils/getUsername'
import challengeIcon from '../../../../../assets/drafts/challenge.svg'
import userEventIcon from '../../../../../assets/drafts/userEvent.svg'
import { getUserEventById, getChallengeById } from '../../../../../redux/apis'
import {
  BottomButtonsContainer,
  Container,
  DraftTypeBanner,
  HoverActions,
  TopButtonsContainer,
  UserAvatar,
  UserName,
  UserProfile,
  Wrapper
} from './BasicDesignCard.styles'

export const BasicDesignCard = ({
  refFn,
  data,
  onClickJoin,
  onClick = onClickJoin,
  topButtons = 'share',
  bottomButtons = 'all',
  fromOwner,
  showAuthor,
  mode,
  setEditPost,
  smartSize = true,
  children,
  onDelete,
  mobileGrid,
  mobileGallery
}) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const dispatch = useDispatch()
  const [image, setImage] = useState({})

  useEffect(() => {
    if (!data) return

    setImage(getImageSource(data))
  }, [data])

  const { objectId, user, userInspiration } = data

  const postId = data?.userInspiration?.objectId || objectId
  const postAuthor = userInspiration?.user || user
  const defaultProfilePic =
    'https://didr9pubr8qfh.cloudfront.net/mobile_other/profile_avatars/Profile5.png'
  const inspiration = data?.userInspiration || data

  const logInCheck = e => {
    if (!isAuthenticated) {
      e.preventDefault()
      dispatch(gotoLogIn())

      return false
    }
  }

  const { data: eventData } = useQuery(
    ['draftEvent', data?.userEvent?.objectId],
    async () => {
      return await getUserEventById(data.userEvent.objectId)
    },
    {
      enabled: !!data?.userEvent
    }
  )

  const { data: challengeData } = useQuery(
    ['draftChallenge', data?.designContest?.objectId],
    async () => {
      return await getChallengeById(data.designContest.objectId)
    },
    {
      enabled: !!data?.designContest
    }
  )
  const dataChallengeEvent = eventData || challengeData

  const isChallengeActive = useMemo(() => {
    if (!dataChallengeEvent) return false
    const momentNow = moment()

    return (
      moment(dataChallengeEvent?.featuredAt?.iso).isBefore(momentNow) &&
      moment(dataChallengeEvent?.expiresAt?.iso).isAfter(momentNow)
    )
  }, [dataChallengeEvent])

  return (
    <Wrapper ref={refFn} onClick={e => onClick(e, data)}>
      <Container
        mobileGallery={mobileGallery}
        smartSize={smartSize}
        mobileGrid={mobileGrid}
      >
        <DesignCanvas
          data={data}
          scalable={mobileGrid || mobileGallery}
          displayRichContent={true}
        />
      </Container>
      {mode === 'drafts' && data?.userEvent && isChallengeActive && (
        <DraftTypeBanner type="draft">
          <img src={userEventIcon} alt="" /> Event Draft
        </DraftTypeBanner>
      )}
      {mode === 'drafts' && data?.designContest && isChallengeActive && (
        <DraftTypeBanner type="challenge">
          <img src={challengeIcon} alt="" /> Challenge Draft
        </DraftTypeBanner>
      )}
      <HoverActions>
        <TopButtonsContainer onClick={e => e.stopPropagation()}>
          {topButtons === 'menu' && (
            <InspirationActionsMenu
              fromOwner={fromOwner}
              inspirationId={postId}
              mode={mode}
              isChallengePost={!!inspiration?.designContest}
              imageUrl={image.src}
              onDelete={onDelete}
              showCaptionModal={() => {
                setEditPost(inspiration)
              }}
            />
          )}
          {showAuthor && (
            <Link
              onClick={logInCheck}
              href={isAuthenticated ? `/dm/${postAuthor.objectId}` : '/'}
            >
              <UserProfile>
                <UserAvatar
                  loading="lazy"
                  src={
                    postAuthor.thumbProfileImageFile
                      ? postAuthor.thumbProfileImageFile.url
                      : defaultProfilePic
                  }
                  alt={postAuthor.uniqueDisplayName}
                />
                <UserName>{getUsername(postAuthor)}</UserName>
              </UserProfile>
            </Link>
          )}
        </TopButtonsContainer>
        {bottomButtons !== 'none' && (
          <BottomButtonsContainer onClick={e => e.stopPropagation()}>
            <LikeBtn postId={postId} numLikes={inspiration?.numLikes || 0} />
            <CommentBtn
              data={inspiration}
              postId={postId}
              commentsCount={inspiration?.numComments || 0}
              type={inspiration.type}
            />
            <GiftBtn postId={postId} numGifts={inspiration.numGifts || '0'} />
          </BottomButtonsContainer>
        )}
        {children}
      </HoverActions>
    </Wrapper>
  )
}
